import { useState } from 'react';
import { RiVideoOnAiLine } from 'react-icons/ri';

import Beta from '@lib/core/src/components/Beta';
import palette from '@lib/core/src/theme/palette';

import InviteJourneyAiModal from '@/components/modals/InviteJourneyAi/InviteJourneyAiModal';
import { useSidebarActions } from '@/store/sidebarStore';
import { useIsSmallScreen } from '@/utils/mediaUtil';

import {
  SidebarListItemButton,
  SidebarList,
  SidebarListItemIcon,
  SidebarListItemText,
  InviteJourneyButton
} from './SidebarStyles';
import { useMenuItems } from './hooks/useMenuItems';

const SidebarMenu = () => {
  const { hideSidebar } = useSidebarActions();
  const isSmallScreen = useIsSmallScreen();
  const { menuItems, handleClick, isActive } = useMenuItems(isSmallScreen, hideSidebar);
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <SidebarList>
      {menuItems.map(item => (
        <SidebarListItemButton
          key={item.label}
          onClick={() => handleClick(item.action)}
          active={isActive(item.path)}
          sx={{
            display:
              (item.isVisibleOnDesktop && !isSmallScreen) ||
              (item.isVisibleOnMobile && isSmallScreen)
                ? 'flex'
                : 'none'
          }}
        >
          <SidebarListItemIcon>{item.icon}</SidebarListItemIcon>
          <SidebarListItemText>{item.label}</SidebarListItemText>
          {item.isBeta && (
            <Beta
              text="New"
              sx={{
                position: 'absolute',
                top: '50%',
                right: '-8px',
                fontSize: '10px',
                transform: 'translateY(-50%)',
                padding: '2px'
              }}
            />
          )}
        </SidebarListItemButton>
      ))}
      <InviteJourneyButton onClick={() => setModalOpen(true)}>
        <RiVideoOnAiLine size={16} color={palette.purple[300]} />
        <SidebarListItemText>Invite JourneyAI</SidebarListItemText>
      </InviteJourneyButton>
      <InviteJourneyAiModal open={isModalOpen} onClose={() => setModalOpen(false)} />
    </SidebarList>
  );
};

export default SidebarMenu;
